const validateEmail = (value) => /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(value);

const validatePWZ = (value) => {
  if (!/^\d{7}$/.test(value) || value[0] === "0") return false;

  const weights = [1, 2, 3, 4, 5, 6];
  const sum = value
    .slice(1)
    .split("")
    .reduce((acc, digit, i) => acc + digit * weights[i], 0);

  return sum % 11 == value[0];
};

const validatePWZF = (value) => {
  if (value.length !== 8) return false;
  if (!/^\d+$/.test(value)) return false;

  const weights = [3, 1, 3, 1, 3, 1, 3, 0];

  const sum = value
    .slice(0, 7)
    .split("")
    .reduce((acc, digit, i) => acc + digit * weights[i], 0);

  const controlDigit = (10 - (sum % 10)) % 10;

  if (parseInt(value[7]) !== controlDigit) return false;

  const chamberCode = parseInt(value.slice(0, 2));
  if (chamberCode < 1 || chamberCode > 20) {
    return false;
  }

  return true;
};

const validateNIP = (value) => {
  if (value.length !== 10) return false;
  if (!/^\d+$/.test(value)) return false;

  const weights = [6, 5, 7, 2, 3, 4, 5, 6, 7];
  const controlDigit = parseInt(value[9]);

  const sum = value
    .slice(0, 9)
    .split("")
    .reduce((acc, digit, i) => acc + digit * weights[i], 0);

  return controlDigit === sum % 11;
};

const validatePhone = (value) => /^[0-9\+]{8,13}$/.test(value);

const validatePostalCode = (value) => /^[0-9]{2}-[0-9]{3}$/.test(value);

const validateTextField = (value) => value.length > 0;

const createValidationElement = (message, className) => {
  const element = document.createElement("div");
  element.classList.add("wlc-validation-error", className);
  element.textContent = message;
  return element;
};

const validateField = (target, func, message, className) => {
  const errorElement = document.querySelector(`.${className}`);
  if (target.closest(".wlc-registration-wc__company.hide") || target.closest(".pwz.hidden")) {
    errorElement?.remove();
    target.classList.remove("wlc-input-error");
    return true;
  }
  if (target.id === "pwz") {
    const title = target.closest(".pwz")?.getAttribute("title");
    if (title === "Numer PWZF") {
      func = validatePWZF;
      message = "Błędny numer PWZF";
    }
  }
  if (!func(target.value)) {
    if (!errorElement) {
      target.after(createValidationElement(message, className));
      target.classList.add("wlc-input-error");
    }
    return false;
  }
  errorElement?.remove();
  target.classList.remove("wlc-input-error");
  return true;
};

const setSubmitButtonState = (submitButton) => {
  const errors = document.querySelectorAll(".wlc-validation-error");
  submitButton.disabled = errors.length > 0;
};

const validateAllTextFields = (container) => {
  const textFields = container.querySelectorAll("input[type='text']");
  let allValid = true;
  textFields.forEach((field) => {
    if (field.id === "pwz") return;
    if (field.id === "nip_1") return;
    if (field.id === "phone_1") return;
    if (field.id === "zip_code_1") return;
    if (field.closest(".pwz.hidden")) return;
    if (field.closest(".wlc-registration-wc__company.hide")) return;
    const name = field.getAttribute("name");
    const fields = ["dname", "name_1", "surname_1", "company_name_1", "street_1", "street_number_1", "city_1"];

    if (!fields.includes(name)) return;

    const isValid = validateField(field, validateTextField, "Wypełnij to pole", `${name}_val`);
    if (!isValid) allValid = false;
  });
  return allValid;
};

const validatePassword = (password) => {
  // Check length
  if (password.length < 10) return false;

  // Check for at least one letter
  const hasLetter = /[a-zA-Z]/.test(password);

  // Check for at least one digit or special character
  const hasDigitOrSpecial = /[0-9!@#$%^&*(),.?":{}|<>]/.test(password);

  return hasLetter && hasDigitOrSpecial;
};

const validationTextField = (textFieldsContainer, submitButton) => {
  textFieldsContainer.addEventListener("focusout", (e) => {
    if (e.target.tagName === "INPUT" && e.target.type === "text") {
      if (e.target.id === "pwz") return;
      if (e.target.id === "nip_1") return;
      if (e.target.id === "phone_1") return;
      if (e.target.id === "zip_code_1") return;
      const name = e.target.getAttribute("name");
      validateField(e.target, validateTextField, "Wypełnij to pole", `${name}_val`);
      setSubmitButtonState(submitButton);
    }
  });
};

const validationRules = {
  email_1: { func: validateEmail, message: "Niepoprawny format adresu e-mail", className: "email_val" },
  email_2: {
    func: validateEmail,
    message: "Adresy e-mail muszą być identyczne",
    className: "email_val2",
    repeat: true,
  },
  pwz: { func: validatePWZ, message: "Błędny numer PWZ", className: "pwz_val" },
  nip_1: { func: validateNIP, message: "Błędny numer NIP", className: "nip_val" },
  phone_1: { func: validatePhone, message: "Błędny numer telefonu", className: "phone_val" },
  zip_code_1: { func: validatePostalCode, message: "Błędny numer kodu pocztowego", className: "zip_val" },
};

const applyValidation = (field, rules, submitButton) => {
  const { func, message, className, repeat } = rules[field.id];
  field.addEventListener("focusout", () => {
    if (repeat) {
      const email_1 = document.querySelector("#email_1");
      validateField(field, (value) => value === email_1.value && func(value), message, className);
    } else {
      validateField(field, func, message, className);
    }
    setSubmitButtonState(submitButton);
  });
};

const setupValidation = (fields, submitButton, rules) => {
  fields.forEach((field) => {
    if (rules[field.id]) applyValidation(field, rules, submitButton);
  });
};

const registerValidation = () => {
  const email_1 = document.querySelector("#email_1");
  const email_2 = document.querySelector("#email_2");
  const pwz = document.querySelector("#pwz");
  const submitButton = document.querySelector(".wlc-registration__submit");

  if (!email_1 || !email_2 || !pwz || !submitButton) return;

  validationTextField(document, submitButton);
  setupValidation([email_1, email_2, pwz], submitButton, validationRules);

  submitButton.addEventListener("click", (e) => {
    const textFieldsValid = validateAllTextFields(document);
    const hasErrors = Array.from([email_1, email_2, pwz]).some(
      (field) =>
        !validateField(
          field,
          validationRules[field.id].func,
          validationRules[field.id].message,
          validationRules[field.id].className,
        ),
    );

    if (!textFieldsValid || hasErrors) e.preventDefault();
  });
};

const profileValidation = () => {
  const email_1 = document.querySelector("#email_1");
  const pwz = document.querySelector("#pwz");
  const nip_1 = document.querySelector("#nip_1");
  const phone_1 = document.querySelector("#phone_1");
  const zip_code_1 = document.querySelector("#zip_code_1");
  const submitButton = document.querySelector(".wlc-my-account__submit");

  if (!email_1 || !pwz || !nip_1 || !phone_1 || !zip_code_1 || !submitButton) return;

  validationTextField(document, submitButton);
  setupValidation([email_1, pwz, nip_1, phone_1, zip_code_1], submitButton, validationRules);

  submitButton.addEventListener("click", (e) => {
    const textFieldsValid = validateAllTextFields(document);
    const hasErrors = Array.from([email_1, pwz, nip_1, phone_1, zip_code_1]).some(
      (field) =>
        !validateField(
          field,
          validationRules[field.id].func,
          validationRules[field.id].message,
          validationRules[field.id].className,
        ),
    );

    if (!textFieldsValid || hasErrors) e.preventDefault();
  });
};

const passwordValidation = () => {
  const current_password = document.querySelector("#current_password");
  const password_1 = document.querySelector("#password_1");
  const password_2 = document.querySelector("#password_2");
  const submitButton = document.querySelector("#wlc_change_password");

  if (!current_password || !password_1 || !password_2 || !submitButton) return;

  const validatePasswordsMatch = (password1, password2) => password1 === password2;

  const validateAndSetState = () => {
    const isCurrentPasswordValid = validateField(
      current_password,
      validatePassword,
      "Hasło musi zawierać co najmniej jedną literę, jedną cyfrę lub znak specjalny oraz 10 znaków",
      "current_password_val",
    );

    const isNewPasswordValid = validateField(
      password_1,
      validatePassword,
      "Hasło musi zawierać co najmniej jedną literę, jedną cyfrę lub znak specjalny oraz 10 znaków",
      "password_1_val",
    );

    const isPasswordsMatch = validateField(
      password_2,
      (value) => validatePasswordsMatch(password_1.value, value),
      "Hasła muszą być identyczne",
      "password_2_val",
    );

    submitButton.disabled = !(isCurrentPasswordValid && isNewPasswordValid && isPasswordsMatch);
  };

  [current_password, password_1, password_2].forEach((field) => {
    field.addEventListener("focusout", validateAndSetState);
  });

  submitButton.addEventListener("click", (e) => {
    const hasErrors = !(
      validateField(
        current_password,
        validatePassword,
        "Hasło musi zawierać co najmniej jedną literę, jedną cyfrę lub znak specjalny oraz 10 znaków",
        "current_password_val",
      ) &&
      validateField(
        password_1,
        validatePassword,
        "Hasło musi zawierać co najmniej jedną literę, jedną cyfrę lub znak specjalny oraz 10 znaków",
        "password_1_val",
      ) &&
      validateField(
        password_2,
        (value) => validatePasswordsMatch(password_1.value, value),
        "Hasła muszą być identyczne",
        "password_2_val",
      )
    );

    if (hasErrors) e.preventDefault();
  });
};

const myAccount = () => {
  const openButton = document.querySelector("#wlc-change-password");
  const closeButton = document.querySelector(".close-popup");
  const popup = document.querySelector(".popup");
  const resetButton = document.querySelector(".wlc-my-account__reset");
  const form = document.querySelector(".wlc-my-account__form");
  const options = document.querySelectorAll(".wlc-registration__option");
  const profession = document.querySelector("#profession");
  const popupReset = document.querySelector(".wlc-my-account__password-reset");
  const changePasswordForm = document.querySelector(".wlc-change-password-form");

  if (
    !openButton ||
    !closeButton ||
    !popup ||
    !resetButton ||
    !form ||
    !options ||
    !profession ||
    !popupReset ||
    !changePasswordForm
  )
    return;

  popupReset.addEventListener("click", (e) => {
    e.preventDefault();
    close(popup);
    changePasswordForm.reset();
  });

  switch (profession.value) {
    case "lekarz":
      options[0].click();
      break;
    case "farmaceuta":
      options[1].click();
      break;
    case "po-studiach-medycznych":
      options[2].click();
      break;
    case "student":
      options[3].click();
      break;
    case "pielegniarka":
      options[4].click();
      break;
    case "wykladowca":
      options[5].click();
      break;
    default:
      options[0].click();
      break;
  }

  async function close(popup) {
    if (popup.open) {
      popup.classList.add("fading");
      await new Promise((resolve) => {
        const listen = () => {
          popup.removeEventListener("animationend", listen);
          popup.classList.remove("fading");
          resolve();
        };
        popup.addEventListener("animationend", listen);
      });
      popup.close();
    }
  }

  openButton.addEventListener("click", (e) => {
    e.preventDefault();
    popup.showModal();
  });

  closeButton.addEventListener("click", (e) => {
    e.preventDefault();
    close(popup);
  });

  popup.addEventListener("click", (e) => {
    if (e.target === popup) close(popup);
  });

  resetButton.addEventListener("click", (e) => {
    e.preventDefault();
    form.reset();
    options[0].click();
  });
};

export { myAccount, registerValidation, profileValidation, passwordValidation };
